import React, { Fragment } from 'react';
import { Subheader, List, ListItem } from 'material-ui';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { localize } from '../../../i18n';
import { getStateTitle } from '../../../utils/textFormat';

const styles = {
  page: {
    background: '#fff',
  },
};

const Item = ({ primaryText, secondaryText }) => (
  <ListItem
    insetChildren
    secondaryText={secondaryText}
    primaryText={primaryText || 'N/A'}
  />
);

const ReservationDetailsList = (props) => {
  const {
    reservation: {
      attributes: {
        checkin_date,
        checkout_date,
        confirmation_id: confirmation,
        email,
        first_name: firstName,
        last_name: lastName,
        phone,
        state,
        locations,
      },
    },
    t,
  } = props;

  let room;

  if (locations) {
    room = locations.map(location => location.name).join(', ');
  }

  const checkinDate = moment(checkin_date).format('MM/DD/YYYY');
  const checkoutDate = moment(checkout_date).format('MM/DD/YYYY');
  const fullName = `${firstName} ${lastName}`;

  return (
    <Fragment>
      <List style={styles.page}>
        <Subheader>{t('Guest Details')}</Subheader>
        <Item
          secondaryText={t('Guest Name')}
          primaryText={fullName}
        />
        <Item
          secondaryText={t('Guest Phone Number')}
          primaryText={phone}
        />
        <Item
          secondaryText={t('Guest Email')}
          primaryText={email}
        />
      </List>

      <List style={styles.page}>
        <Subheader>{t('Stay Details')}</Subheader>
        <Item
          secondaryText={t('Checked-In Date')}
          primaryText={checkinDate}
        />
        <Item
          secondaryText={t('Checked-Out Date')}
          primaryText={checkoutDate}
        />
        <Item
          secondaryText={t('Room Number')}
          primaryText={room}
        />
        <Item
          secondaryText={t('Reservation State')}
          primaryText={getStateTitle(state)}
        />
        <Item
          secondaryText={t('Confirmation Number')}
          primaryText={confirmation}
        />
      </List>
    </Fragment>
  );
};

ReservationDetailsList.propTypes = {
  reservation: PropTypes.shape({}),
  t: PropTypes.func,
};

Item.propTypes = {
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
};

export default localize(ReservationDetailsList);



// WEBPACK FOOTER //
// ./src/views/chat/components/ReservationDetailsList.js